import Vue from "vue";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";
import VueFormGenerator from "vue-form-generator";
import firebaseCredentials from "./firebase-credentials.json";
import "vue-form-generator/dist/vfg.css";

import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);
//import Vue from 'vue'
//import IdleVue from 'idle-vue'

const firebaseInstance = firebase.initializeApp(firebaseCredentials);
//const eventsHub = new Vue()

Vue.config.productionTip = false;
Vue.use(Vuelidate);


const auth = firebaseInstance.auth();

auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

Vue.prototype.$firebase = firebaseInstance;
Vue.prototype.$auth = auth;
Vue.prototype.$db = firebaseInstance.firestore();
Vue.prototype.$storage = firebaseInstance.storage();

Vue.use(VueFormGenerator);



router.$store = store;
router.$auth = auth;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
